import api from './api';

export const getBudgetPlanYears = () => api.get('/budget-plan/years');
export const getBudgetPlan = (year) => api.get(`/budget-plan/${year}`);
export const createBudgetPlan = (data) => api.post('/budget-plan', data);
export const deleteBudgetPlan = (year) => api.delete(`/budget-plan/${year}`);
export const updatePlanItem = (year, itemId, data) =>
  api.put(`/budget-plan/${year}/item/${itemId}`, data);
export const addPlanOverride = (year, data) =>
  api.post(`/budget-plan/${year}/override`, data);
export const removePlanOverride = (year, overrideId) =>
  api.delete(`/budget-plan/${year}/override/${overrideId}`);
export const getMonthlyTracking = (year, month) =>
  api.get(`/budget-plan/${year}/tracking/${month}`);
export const getYearlyTracking = (year) =>
  api.get(`/budget-plan/${year}/tracking`);
export const updatePlanStatus = (year, status) =>
  api.put(`/budget-plan/${year}/status`, { status });
